module.exports = __webpack_public_path__ + "img/guide_wind.5161a16e.svg";